import { gql } from '@apollo/client';

// Perf geo (2026-07-21): selection recortada a `latitude longitude` — los 4
// call-sites v1 (selectors/actions.ts, LocationForm, MapWithSegments ×2)
// solo mapean lat/lng y calculan el centro por índice medio; NINGUNO lee
// id/pkKm/pkMeter/direction del resultado (verificado con grep; el backend
// re-verificó lo mismo al decimar server-side a ≤200 vértices). Sin `id` los
// puntos quedan embebidos (no normalizados) bajo Query.geoPositionRoads —
// merge snapshot explícito en policies.ts. Con la decimación backend, C-25
// entera pasa de 202 kB a ~8-10 kB por ventana.
export const GET_POSITION_ROADS = gql`
  query GeoPositionRoads($input: FilterGeoPositionRoad!) {
    geoPositionRoads(input: $input) {
      latitude
      longitude
    }
  }
`;

// V4 D13 (2026-04-22): inversa GPS → PK. Consumido por `useGpsToPK` para
// prefill de PK en los modales del timer (NewSurveillanceSegmentModal,
// ChangeDirectionModal [PR 4 pendiente], PauseSurveillanceRouteModal).
export const PK_BY_COORDINATES = gql`
  query PkByCoordinates($input: FindPkByCoordinatesInput!) {
    pkByCoordinates(input: $input) {
      pkKm
      pkMeter
      distance
      # Multi-carretera (2026-08-15): en cuál de las carreteras del recorrido
      # cayó el punto. Sin esto el PK es ambiguo entre una troncal y su ramal.
      roadId
    }
  }
`;

// ═══════════════════════════════════════════════════════════════════
// Malla SIN decimar, para resolver el PK sin cobertura.
//
// 🔴 APARTE de `GET_POSITION_ROADS`, que va capada a 200 vértices porque su
// trabajo es pintar polilíneas en el mapa.
// Para un recorrido de 153 km eso es un vértice cada 750 m: sirve para dibujar
// una línea, no para medir un PK. Confundirlas es lo que hacía que el PK
// offline se calculara sobre una geometría recortada.
// ═══════════════════════════════════════════════════════════════════
export const ROAD_PK_MESH = gql`
  query RoadPkMesh($concessionId: ID) {
    roadPkMesh(concessionId: $concessionId) {
      roadId
      roadName
      direction
      vertices {
        pkKm
        pkMeter
        latitude
        longitude
      }
    }
  }
`;

// Vías candidatas para una posición, con su PK, su distancia y el rango
// declarado de la vía. Ordenadas por distancia y SIN recortar por umbral: el
// recorte lo hace el cliente, que es quien necesita poder decir «la más
// cercana es la C-25, a 480 m» en vez de callarse.
/**
 * ⚠️ Hoy **sin consumidores en esta rama** (verificado 2026-08-26).
 *
 * No es código muerto por descuido: la consume el botón «Autolocalizar PK» de
 * Actuación y Accidente, que vive en la rama del grupo `apk`. Se deja aquí para
 * que ese merge no tenga que reintroducirla.
 *
 * 🔴 Y conviene saber que es la BUENA: `locatePk` proyecta sobre la polilínea,
 * mientras que `pkByCoordinates` cogía el vértice más cercano — hasta que se
 * arregló el 2026-08-26 (Fase 1, T1.5). Ahora las dos proyectan.
 */
export const LOCATE_PK = gql`
  query LocatePk($input: LocatePkInput!) {
    locatePk(input: $input) {
      roadId
      roadName
      direction
      pkKm
      pkMeter
      distance
      roadPkInitKm
      roadPkInitMeter
      roadPkEndKm
      roadPkEndMeter
    }
  }
`;
